import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router'
import { HttpClient } from '@angular/common/http';
import { bmxurl, getAccess, ConvertDateFromDB, ConvertDateToDB} from 'src/globals';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { packageObj, cPackage, repeatblock } from 'src/types/package';
import { cResource, resource } from 'src/types/resource';
import { cAdmission } from 'src/types/admission';
import { tag_returndata } from 'src/types/tag_returndata';
import { resourceType_returndata } from 'src/types/resource_returndata';
import { admission_returndata } from 'src/types/admission_returndata';
import { v4 as uuidv4  } from 'uuid';
import { packagerule_returndata } from 'src/types/packagerule_returndata';
import { restriction_returndata } from 'src/types/restriction_returndata';
import { depositpolicy_returndata } from 'src/types/depositpolicy_returndata';

import { resourcegroupname_returndata } from 'src/types/resourcegroupname_returndata';
import { resourcegroupname } from 'src/types/resourcegroupname';
import { cClass } from 'src/types/class';
import { class_returndata } from 'src/types/class_returndata';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { AuthService } from '@auth0/auth0-angular';
import { confirmation_returndata } from 'src/types/confirmation_returndata';
import { environment } from 'src/environments/environment';
import { users_returndata } from 'src/types/user_returndata';
import { warnings_returndata } from 'src/types/warnings_returndata';
import { GlobalService } from '../_services/global.service';
import { BusyService } from '../_services/busy.service';


@Component({
    selector: 'app-packageedit',
    templateUrl: './packageedit.component.html',
    styleUrls: ['./packageedit.component.css']
})

export class PackageeditComponent implements OnInit {
    VenueID: string = localStorage.getItem("SmartVenueID")!;
    WaiverActive: boolean = localStorage.getItem("WaiverActive") == "true" ? true : false; 
    PackageObj: cPackage;
    httpResponse: any;
    id: string;
    stateOptionsRes: any;
    stateOptionsPPP: any;
    stateOptionsMI: any;
    stateOptionsPart: any;
    stateOptions: any;
    stateOptionsComplexSimple: any;

    packageLen: number = 0;
    availableResources: any;
    selectedResources: any = [];
    stateOptionsSelMode: any;
    stateOptionsSel: any;
    stateOptionsQty: any;
    stateOptionsQty2: any;
    stateOptionsStart: any;
    stateOptionsBool: any;
    stateOptionsVisibility: any;
    stateOptionsPrice: any;

    availableAdmissions: any = [];
    selectedAdmissions: any = [];
    draggedAdmission: any;
    DepositPolicies: any;

    builtResources: any;
    builtAdmissions: any;

    packageRules: any = [];
    packageRestriction: any = [];
    classes: cClass[];

    tags: any;
    items: any;
    activeIndex: number;

    packageNameValid: boolean = true;
    packageDescValid: boolean = true;
    maxNotLessThanMinValid: boolean = true;

    itinerary: string = "";
    discrepantitinerary: string[] = [];

    availableResourceGroups: resourcegroupname[] = [];
    selectedItems: any;

    showDialog: boolean;
    showPartyPackageDialog: boolean = false;
    showDefaultFeeDialog: boolean = false;
    defaultBookingFee: any = null;

    hubConnection: HubConnection;

    HTMLbmxurl: string = bmxurl;
    Identifier: string = uuidv4();
    FileChosen: string = "";

    Confirmations: any[];
    Warnings: any[];

    SortedItinerary: any[];

    AccessAllowed: boolean = false;
    CompletedLoading: boolean = false;

    BookingQuestionnaires: any[] = [];
    CurrencySymbol: string = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;

    delayBookingStateOptions: any[] = [];

    stateOptionsRangeType: any[]
    stateOptions3: any[];

    bookingCannotBeMadeWithinXMinutesD: number = 0;
    bookingCannotBeMadeWithinXMinutesH: number = 0;
    bookingCannotBeMadeWithinXMinutesM: number = 0;

    bookingscannotbemadeafterxDays: number = 0;

    LinkedAdmissions: boolean = false;

    CurrentSelectedAdmission: cAdmission;
    CurrentSelectedLinkedAdmission: cAdmission;

    publicDepositPolicy: boolean = true;

    BookingTimeout: Number = 5;

    //Repeat dates, picked the same way as event dates. No times are set here: the customer picks a
    //time on each date when they book.
    RepeatStartDate: Date = new Date();
    RepeatEndDate: Date = new Date();
    RepeatDoesRepeat: boolean = false;
    RepeatOptionInterval: any[];
    RepeatOptionPeriod: any[];
    ChosenRepeatOptionInterval: any;
    ChosenRepeatOptionPeriod: any;
    RepeatMonday: boolean = false;
    RepeatTuesday: boolean = false;
    RepeatWednesday: boolean = false;
    RepeatThursday: boolean = false;
    RepeatFriday: boolean = false;
    RepeatSaturday: boolean = false;
    RepeatSunday: boolean = false;
    //The time the package runs at, as in the Event editor. Repeating every so many hours adds several
    //times on the start date, up to the end time.
    RepeatHours: any[] = [];
    RepeatMinutes: any[] = [];
    RepeatStartHour: string = "10";
    RepeatStartMinute: string = "00";
    RepeatEndHour: string = "17";
    RepeatEndMinute: string = "00";
    RepeatDateError: boolean = false;
    RepeatChosenDates: string[] = [];
    //Only kept while the page is open, so a date moved out by mistake can be put back before saving.
    RepeatExcludedDates: string[] = [];
    //Fixed blocks. The venue says how many sessions make a block and the chosen dates are cut
    //into runs of that length, in date order.
    RepeatModeOptions: any[] = [];
    RepeatSessionsPerBlock: number = 6;
    RepeatBlocks: repeatblock[] = [];


    constructor(private route: ActivatedRoute,
      private http: HttpClient,
      private router: Router,
      private messageService: MessageService,
      private auth: AuthService, private globalService: GlobalService,
      private busyService: BusyService) {
      this.stateOptionsRes = [{ label: 'Shared', value: false }, { label: 'Exclusive', value: true }];
      this.stateOptionsPPP = [{ label: 'Per Booking', value: true }, { label: 'Per Person', value: false }];
      this.stateOptions = [{ label: 'Yes', value: true }, { label: 'No', value: false }];
      this.stateOptionsMI = [{ label: 'Yes', value: true }, { label: 'No', value: false }];
      this.stateOptionsPart = [{ label: 'Yes', value: true }, { label: 'No', value: false }];
      this.stateOptionsPrice = [{ label: 'Fixed Price', value: true }, { label: 'Per Person', value: false }];
      this.stateOptionsBool = [{ label: 'Yes', value: false }, { label: 'No', value: true }];
      this.stateOptionsVisibility = [{ label: 'Hidden', value: 'NEITHER' }, { label: 'Public Bookings Only', value: 'PUBLIC' }, { label: 'Preview/Venue Only', value: 'VENUE' }, { label: 'Public and Venue Bookings', value: 'BOTH' }];

      this.stateOptionsRangeType = [{ label: 'Date Range', value: 0 }, { label: 'Days before', value: 1 }];

      this.stateOptionsSel =  [{ label: 'Customer chooses from any', value: "ANY" }, { label: 'Customer chooses from list', value: "LIST" }, { label: 'System chooses from any', value: "SYSTEMANY" }, { label: 'System chooses from list', value: "SYSTEMLIST" }];
      this.stateOptionsQty =  [{ label: 'Group Size', value: "GROUPSIZE" }, { label: 'Participant', value: "PARTICIPANT" }, { label: 'Customer Chooses', value: "CUSTOM" }];
      
      this.stateOptionsQty2 =  [{ label: 'Group Size', value: "GROUPSIZE" }, { label: 'Participant', value: "PARTICIPANT" }];
      
      this.stateOptionsStart = [{ label: 'At Start', value: "ATSTART"}, { label: 'At End', value: "ATEND"}, { label: 'Offset', value: "OFFSET"}];
      this.stateOptionsComplexSimple = [{ label: 'Simple', value: 'SIMPLE' }, { label: 'Complex', value: "COMPLEX"}];

      this.delayBookingStateOptions = [{label: 'No', value: false}, {label: 'Yes', value: true}];

      this.stateOptions3 = [{ label: 'Fixed Amount', value: "FIXED" }, { label: 'Percentage', value: "PERCENTAGE" }];

      //The Event editor's repeat choices, without Years.
      this.RepeatModeOptions = [
        {label: 'Customer picks dates', value: 'FREE'},
        {label: 'Fixed blocks', value: 'BLOCKS'}
      ];

      this.RepeatOptionInterval = [{name: 'No Repeat', code: 'No Repeat'}];
      for(let i = 1; i <= 31; i++)
      {
        this.RepeatOptionInterval.push({name: i.toString(), code: i.toString()});
      }

      this.RepeatOptionPeriod = [
        {name: 'Hour(s)', code: 'Hour(s)'},
        {name: 'Day(s)', code: 'Day(s)'},
        {name: 'Week(s)', code: 'Week(s)'},
        {name: 'Month(s)', code: 'Month(s)'}
      ];

      this.ChosenRepeatOptionInterval = this.RepeatOptionInterval[1];
      this.ChosenRepeatOptionPeriod = this.RepeatOptionPeriod[2];

      for(let hour = 0; hour < 24; hour++)
      {
        const value = ('00' + hour).slice(-2);
        this.RepeatHours.push({name: value, code: value});
      }

      for(let minute = 0; minute < 60; minute += 5)
      {
        const value = ('00' + minute).slice(-2);
        this.RepeatMinutes.push({name: value, code: value});
      }

      this.loadConfirmations(false);
      this.loadWwarnings(false);
      this.loadResources(false);
      this.loadAdmissions(false);
      //this.loadTags(false);
      this.loadRestrictions(false);
      this.loadPackageRules(false);
      this.loadDepositPolidies(false);
      this.loadClasses(false);
      this.loadQuestionnaires();
      this.loadDefaultBookingFee();

      this.PackageObj = {
        id: null,
        packageId: null,
        name: "",
        eventid: null,
        description: "",
        imageurl: "",
        message: "",
        disabled: false,
        venueID: this.VenueID,
        resources: [],
        startTimes: null,
        admissions: [],
        packageLength: 0,
        questionnaire: null,
        visibility: "VENUE",
        min:0,
        max:0,
        tags: null,
        startDate: new Date(),
        endDate:  this.add_years(new Date(), 5),
        colour: "#990000",
        packageRule: null,
        packageRestriction: null,
        extras: null,
        publicDepositPolicy: null,
        venueDepositPolicy: null,
        additionalresources: null,
        confirmation: null,
        warning: null,
        originatingid:  "",
        bookingscannotbemadewithinxminutes: 0,
        bookingscannotbemadeafterxminutes: 0,
        cannotmakebookingstoday: true,
        discounttype: "PERCENTAGE",
        discountamount: 0,
        discountcode: null,
        discountstart: new Date(),
        discountend: this.addYears(new Date(), 5),
        earlybirddiscount: false,
        discountrangetype: 0,
        discountdaysbefore: 0,
        imageguid: this.Identifier,
        bookingtimeout: 5,
        maxcalendarmonths: 3,
        packageupgrades: [],
        packageabupgrades: [],
        waiverrequired: false,
        ispartypackage: false,
        bookingfeeid: null,
        portaltemplateid: null,
        cannotbepaidwithvoucher: false,
        repeatable: false,
        repeatdates: [],
        repeatmode: 'FREE',
        repeatblocks: [],
        repeatmaxdates: 0,
        repeatblockpricefrom: 0
    };

    if(this.PackageObj.imageguid == null || this.PackageObj.imageguid == "")
    {
      this.Identifier = uuidv4();
      this.PackageObj.imageguid = this.Identifier;
    }

    }

    removeLinkedDiscountAdmission(adm)
    {
      this.PackageObj.admissions.forEach(element => {
        if(element.linkeddiscounts != null)
        {
          element.linkeddiscounts = element.linkeddiscounts.filter(obj => obj.admissionid !== adm.admissionid);
        }
      });
    }

    addAdmissionToLinkedDiscount(adm){  
      if(this.CurrentSelectedAdmission != null)
      {
        if (adm.linkeddiscounts == null)
          adm.linkeddiscounts = [];

        let found: boolean = false;
        adm.linkeddiscounts.forEach(element => {
          if(element.admissionid == this.CurrentSelectedAdmission.admissionid)
            found = true;
        });

        if(!found)
        {
          let newLinkedAdm: any = {
            admissionname: this.CurrentSelectedAdmission.name,
            threshold: 1,
            percentagediscount: 100,
            admissionid: this.CurrentSelectedAdmission.admissionid,
            id: adm.id
          }
          adm.linkeddiscounts.push(newLinkedAdm);
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Error', detail:'Admission already linked'});
        }
      }
      else
      {
        this.messageService.add({severity:'error', summary:'Error', detail:'You must select an admission to link to'});
      }
    }

    
    removeLinkedAdmission(adm)
    {
      this.PackageObj.admissions.forEach(element => {
        if(element.linkedadmissions != null)
        {
          element.linkedadmissions = element.linkedadmissions.filter(obj => obj.admissionid !== adm.admissionid);
        }
      });
    }

    addAdmissionToLinked(adm){  
      if(this.CurrentSelectedLinkedAdmission != null)
      {
        if (adm.linkedadmissions == null)
          adm.linkedadmissions = [];

        let found: boolean = false;
        adm.linkedadmissions.forEach(element => {
          if(element.admissionid == this.CurrentSelectedLinkedAdmission.admissionid)
            found = true;
        });

        if(!found)
        {
          let newLinkedAdm: any = {
            admissionname: this.CurrentSelectedLinkedAdmission.name,
            threshold: 1,
            percentagediscount: 100,
            admissionid: this.CurrentSelectedLinkedAdmission.admissionid,
            id: adm.id
          }
          adm.linkedadmissions.push(newLinkedAdm);
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Error', detail:'Admission already linked'});
        }
      }
      else
      {
        this.messageService.add({severity:'error', summary:'Error', detail:'You must select an admission to link to'});
      }
    }

    add_years(dt,n) 
    {
    return new Date(dt.setFullYear(dt.getFullYear() + n));      
    }

    addYears(date: Date, years: number): Date {
      date.setFullYear(date.getFullYear() + years);
      return date;
    }

    uploadedFile(event){
      this.PackageObj.imageurl = event.originalEvent.body.data;
      let newNonce = uuidv4();

      this.FileChosen = event.originalEvent.body.data + "?n=" + newNonce;
    }

    onErrorFileUpload(event){
      this.messageService.add({ severity: 'error', summary: 'Image not uploaded', detail: 'Could not upload image: ' + event.error });
    }

    doRefresh(){
      if(this.id != "0")
      {
        this.http.get(bmxurl + "package/" + this.VenueID + "/" + this.id).subscribe(response => {
          this.httpResponse = response;
          this.PackageObj = {
            id: (this.httpResponse.data as cPackage).id,
            packageId: (this.httpResponse.data as cPackage).packageId,
            name: (this.httpResponse.data as cPackage).name,
            eventid: (this.httpResponse.data as cPackage).eventid,
            description: (this.httpResponse.data as cPackage).description,
            imageurl: (this.httpResponse.data as cPackage).imageurl,
            message: (this.httpResponse.data as cPackage).message,
            disabled: (this.httpResponse.data as cPackage).disabled,
            venueID: (this.httpResponse.data as cPackage).venueID,
            resources: (this.httpResponse.data as cPackage).resources,
            startTimes: (this.httpResponse.data as cPackage).startTimes,
            admissions: (this.httpResponse.data as cPackage).admissions,
            packageLength: (this.httpResponse.data as cPackage).packageLength,
            questionnaire: (this.httpResponse.data as cPackage).questionnaire,
            min: (this.httpResponse.data as cPackage).min,
            max: (this.httpResponse.data as cPackage).max,
            tags: (this.httpResponse.data as cPackage).tags,

            startDate: ConvertDateFromDB((this.httpResponse.data as cPackage).startDate),
            endDate: ConvertDateFromDB((this.httpResponse.data as cPackage).endDate),

            visibility: (this.httpResponse.data as cPackage).visibility,
            colour: (this.httpResponse.data as cPackage).colour,
            packageRule: (this.httpResponse.data as cPackage).packageRule,
            packageRestriction: (this.httpResponse.data as cPackage).packageRestriction,
            extras: (this.httpResponse.data as cPackage).extras,
            publicDepositPolicy: (this.httpResponse.data as cPackage).publicDepositPolicy,
            venueDepositPolicy: (this.httpResponse.data as cPackage).venueDepositPolicy,
            additionalresources:  (this.httpResponse.data as cPackage).additionalresources,
            confirmation: (this.httpResponse.data as cPackage).confirmation,
            warning: (this.httpResponse.data as cPackage).warning,
            originatingid: (this.httpResponse.data as cPackage).originatingid,
            bookingscannotbemadewithinxminutes: (this.httpResponse.data as cPackage).bookingscannotbemadewithinxminutes,
            bookingscannotbemadeafterxminutes: (this.httpResponse.data as cPackage).bookingscannotbemadeafterxminutes,
            cannotmakebookingstoday: (this.httpResponse.data as cPackage).cannotmakebookingstoday,
            discounttype: (this.httpResponse.data as cPackage).discounttype,
            discountamount: (this.httpResponse.data as cPackage).discountamount,
            discountcode: (this.httpResponse.data as cPackage).discountcode,

            discountstart: ConvertDateFromDB((this.httpResponse.data as cPackage).discountstart),
            discountend: ConvertDateFromDB((this.httpResponse.data as cPackage).discountend),

            earlybirddiscount: (this.httpResponse.data as cPackage).earlybirddiscount,
            discountrangetype: (this.httpResponse.data as cPackage).discountrangetype,
            discountdaysbefore: (this.httpResponse.data as cPackage).discountdaysbefore,
            imageguid: (this.httpResponse.data as cPackage).imageguid,
            bookingtimeout: (this.httpResponse.data as cPackage).bookingtimeout,
            maxcalendarmonths: (this.httpResponse.data as cPackage).maxcalendarmonths,
            packageupgrades: (this.httpResponse.data as cPackage).packageupgrades,
            packageabupgrades: (this.httpResponse.data as cPackage).packageabupgrades,
            waiverrequired: (this.httpResponse.data as cPackage).waiverrequired,
            ispartypackage: (this.httpResponse.data as cPackage).ispartypackage,
            bookingfeeid: (this.httpResponse.data as cPackage).bookingfeeid,
            portaltemplateid: (this.httpResponse.data as cPackage).portaltemplateid,
            cannotbepaidwithvoucher: (this.httpResponse.data as cPackage).cannotbepaidwithvoucher,
            repeatable: (this.httpResponse.data as cPackage).repeatable ?? false,
            repeatdates: (this.httpResponse.data as cPackage).repeatdates ?? [],
            repeatmode: (this.httpResponse.data as cPackage).repeatmode ?? 'FREE',
            repeatblocks: (this.httpResponse.data as cPackage).repeatblocks ?? [],
          repeatmaxdates: (this.httpResponse.data as cPackage).repeatmaxdates ?? 0,
          repeatblockpricefrom: (this.httpResponse.data as cPackage).repeatblockpricefrom ?? 0
          }
          this.loadRepeatDates();
          this.buildItinerary();
          this.showDialog = false;

        }, error => {

        });
      }
    }

    ngOnInit(): void {

      this.globalService.setSmallScreenMenu(false);

      let userid = localStorage.getItem("SmartUserID");

      this.http.get(bmxurl + "User/" + userid).subscribe(async response => {
        this.httpResponse =  (response as users_returndata)
        if(this.httpResponse.succeeded)
        {
          let user = this.httpResponse.data;
  
          if(getAccess("PACKAGE", user)){
            this.AccessAllowed = true;

            
          this.id = this.route.snapshot.paramMap.get('id');
    
          this.auth.getAccessTokenSilently().subscribe(tokenReturned => {
            this.hubConnection = new HubConnectionBuilder()
            .withUrl(environment.servicestarget + "/venue/" + this.VenueID, { 
            accessTokenFactory: () => tokenReturned 
          }).build();
      
          this.hubConnection.start();
      
          this.hubConnection.on("packageEvent", data => {
            if(data.packageId == this.id && data.packageId != '0') 
              this.showDialog = true;
          });
          
          });
    
          this.items = [
            {label: 'Package Details'},
            {label: 'Resources'},
            {label: 'Admissions'}
          ];
    
          if(this.id != "0")
          {
            this.http.get(bmxurl + "TagList/" + this.VenueID + "/" + false).subscribe(response => {
              this.tags = (response as tag_returndata).data;
              this.http.get(bmxurl + "package/" + this.VenueID + "/" + this.id).subscribe(response => {
                this.httpResponse = response;
  
                this.Identifier = (this.httpResponse.data as cPackage).imageguid;
  
                this.PackageObj = {
                  id: (this.httpResponse.data as cPackage).id,
                  packageId: (this.httpResponse.data as cPackage).packageId,
                  name: (this.httpResponse.data as cPackage).name,
                  eventid: (this.httpResponse.data as cPackage).eventid,
                  description: (this.httpResponse.data as cPackage).description,
                  imageurl: (this.httpResponse.data as cPackage).imageurl,
                  message: (this.httpResponse.data as cPackage).message,
                  disabled: (this.httpResponse.data as cPackage).disabled,
                  venueID: (this.httpResponse.data as cPackage).venueID,
                  resources: (this.httpResponse.data as cPackage).resources,
                  startTimes: (this.httpResponse.data as cPackage).startTimes,
                  admissions: (this.httpResponse.data as cPackage).admissions,
                  packageLength: (this.httpResponse.data as cPackage).packageLength,
                  questionnaire: (this.httpResponse.data as cPackage).questionnaire,
                  min: (this.httpResponse.data as cPackage).min,
                  max: (this.httpResponse.data as cPackage).max,
                  tags: (this.httpResponse.data as cPackage).tags,
                  packageupgrades: (this.httpResponse.data as cPackage).packageupgrades,  
                  startDate:  new Date((this.httpResponse.data as cPackage).startDate),
                  endDate:  new Date((this.httpResponse.data as cPackage).endDate),
                  visibility: (this.httpResponse.data as cPackage).visibility,
                  colour: (this.httpResponse.data as cPackage).colour,
                  packageRule: (this.httpResponse.data as cPackage).packageRule,
                  packageRestriction: (this.httpResponse.data as cPackage).packageRestriction,
                  extras: (this.httpResponse.data as cPackage).extras,
                  publicDepositPolicy: (this.httpResponse.data as cPackage).publicDepositPolicy,
                  venueDepositPolicy: (this.httpResponse.data as cPackage).venueDepositPolicy,
                  additionalresources: (this.httpResponse.data as cPackage).additionalresources,
                  confirmation: (this.httpResponse.data as cPackage).confirmation,
                  warning: (this.httpResponse.data as cPackage).warning,
                  originatingid:  (this.httpResponse.data as cPackage).originatingid,
                  bookingscannotbemadewithinxminutes: (this.httpResponse.data as cPackage).bookingscannotbemadewithinxminutes,
                  bookingscannotbemadeafterxminutes: (this.httpResponse.data as cPackage).bookingscannotbemadeafterxminutes,
                  cannotmakebookingstoday: (this.httpResponse.data as cPackage).cannotmakebookingstoday,
                  discounttype: (this.httpResponse.data as cPackage).discounttype,
                  discountamount: (this.httpResponse.data as cPackage).discountamount,
                  discountcode: (this.httpResponse.data as cPackage).discountcode,
                  discountstart: new Date((this.httpResponse.data as cPackage).discountstart),
                  discountend: new Date((this.httpResponse.data as cPackage).discountend),
                  earlybirddiscount: (this.httpResponse.data as cPackage).earlybirddiscount,
                  discountrangetype: (this.httpResponse.data as cPackage).discountrangetype,
                  discountdaysbefore: (this.httpResponse.data as cPackage).discountdaysbefore,
                  imageguid : (this.httpResponse.data as cPackage).imageguid,
                  bookingtimeout: (this.httpResponse.data as cPackage).bookingtimeout,
                  maxcalendarmonths: (this.httpResponse.data as cPackage).maxcalendarmonths,
                  packageabupgrades: (this.httpResponse.data as cPackage).packageabupgrades,
                  waiverrequired: (this.httpResponse.data as cPackage).waiverrequired,
                  ispartypackage: (this.httpResponse.data as cPackage).ispartypackage,
                  bookingfeeid: (this.httpResponse.data as cPackage).bookingfeeid,
                  portaltemplateid: (this.httpResponse.data as cPackage).portaltemplateid,
                  cannotbepaidwithvoucher: (this.httpResponse.data as cPackage).cannotbepaidwithvoucher,
            repeatable: (this.httpResponse.data as cPackage).repeatable ?? false,
            repeatdates: (this.httpResponse.data as cPackage).repeatdates ?? [],
            repeatmode: (this.httpResponse.data as cPackage).repeatmode ?? 'FREE',
            repeatblocks: (this.httpResponse.data as cPackage).repeatblocks ?? [],
          repeatmaxdates: (this.httpResponse.data as cPackage).repeatmaxdates ?? 0,
          repeatblockpricefrom: (this.httpResponse.data as cPackage).repeatblockpricefrom ?? 0
                }
  
                if(this.PackageObj.maxcalendarmonths == 0 || this.PackageObj.maxcalendarmonths == null)
                {
                  this.PackageObj.maxcalendarmonths = 3;
                }
  
                if(this.PackageObj.bookingtimeout == 0)
                  this.PackageObj.bookingtimeout = 300; 
  
                this.BookingTimeout = this.PackageObj.bookingtimeout / 60;
                
               this.PackageObj.admissions.forEach(adm => {
                  if(adm.linkedadmissions != null)
                  {
                    adm.uselinkedadmissions = true;
                  }
                  else
                  {
                    adm.uselinkedadmissions = false;
                  }
  
                  if(adm.linkeddiscounts != null)
                    {
                      adm.uselinkeddiscounts = true;
                    }
                    else
                    {
                      adm.uselinkeddiscounts = false;
                    }
                });
  
  
                this.Identifier = this.PackageObj.imageguid;
  
                if(this.PackageObj.imageguid == null || this.PackageObj.imageguid == "")
                {
                  this.Identifier = uuidv4();
                  this.PackageObj.imageguid = this.Identifier;
                }
                
                this.bookingCannotBeMadeWithinXMinutesD = Math.floor(this.PackageObj.bookingscannotbemadewithinxminutes / 1440);
                this.bookingCannotBeMadeWithinXMinutesH = Math.floor((this.PackageObj.bookingscannotbemadewithinxminutes % 1440) / 60);
                this.bookingCannotBeMadeWithinXMinutesM = this.PackageObj.bookingscannotbemadewithinxminutes % 60;
                
                this.bookingscannotbemadeafterxDays = this.PackageObj.bookingscannotbemadeafterxminutes / 1440;
  
                this.FileChosen = this.PackageObj.imageurl;
                this.loadRepeatDates();
                this.buildItinerary();
      
              }, error => {
              });
            }, error => {
            })
          }
          else
          {
            this.http.get(bmxurl + "TagList/" + this.VenueID + "/" + false).subscribe(response => {
              this.tags = (response as tag_returndata).data;
            }, error => {
               this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Tags, error:' + error.messages[0]});
            })
          }
          }
  
          this.CompletedLoading = true;

        }
      }, error => {
        this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
      });


    }

    loadQuestionnaires(){
      this.http.get(bmxurl + "QuestionnaireList/" + this.VenueID).subscribe(response => {
        this.BookingQuestionnaires = (response as any).data;
      }, error => {
        this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Questionnaires, error:' + error.messages[0]});
      });
    }

    genRandomNum()
    {
      return Math.floor((Math.random()*10000)+1).toString();
    }

    loadConfirmations(showdisabled: boolean) {
      this.http.get(bmxurl + "ConfirmationList/" + this.VenueID).subscribe(response => {
        this.Confirmations = (response as confirmation_returndata).data;
      }, error => {
      });
    }

    loadWwarnings(showdisabled: boolean) {
      this.http.get(bmxurl + "WarningList/" + this.VenueID + "/" + showdisabled).subscribe(response => {
        this.Warnings = (response as warnings_returndata).data;
      }, error => {
      });
    }

    loadClasses(showdisabled: boolean) {
      this.http.get(bmxurl + "ClassList/" + this.VenueID).subscribe(response => {
        this.classes = (response as class_returndata).data;
      }, error => {
      });
    }

    loadRestrictions(showdisabled: boolean) {
      this.http.get(bmxurl + "RestrictionList/" + this.VenueID).subscribe(response => {
        this.packageRestriction = (response as restriction_returndata);
      }, error => {
      });
    }

    loadResourceGroups(showdisabled: boolean) {
      this.http.get(bmxurl + "ResourceGroupNameList/" + this.VenueID + "/" + showdisabled).subscribe(response => {
        this.availableResourceGroups = (response as resourcegroupname_returndata).data;
      }, error => {
      });
    }

    loadPackageRules(showdisabled: boolean) {
      this.http.get(bmxurl + "PackageTypeList/" + this.VenueID).subscribe(response => {
        this.packageRules = (response as packagerule_returndata);
      }, error => {
      });
    }

    loadResources(showdisabled: boolean) {
      this.http.get(bmxurl + "ResourceListForPackage/" + this.VenueID + "/" + showdisabled).subscribe(response => {
        let allresources = (response as resourceType_returndata).data.filter(obj => obj.eventid == null || obj.eventid == '')
        
        this.availableResources = allresources;
      }, error => {
      });
    }

    async loadTags(showdisabled: boolean) {
      this.http.get(bmxurl + "TagList/" + this.VenueID + "/" + showdisabled).subscribe(response => {
        this.tags = (response as tag_returndata).data;
      }, error => {
      });
    }

    loadAdmissions(showdisabled: boolean) {
      this.http.get(bmxurl + "AdmissionList/" + this.VenueID + "/" + showdisabled).subscribe(response => {
        this.availableAdmissions = (response as admission_returndata).data;
      }, error => {
      });
    }

    loadDepositPolidies(showdisabled: boolean) {
      this.http.get(bmxurl + "DepositPolicyList/" + this.VenueID + "/" + showdisabled).subscribe(response => {
        this.DepositPolicies = (response as depositpolicy_returndata).data;
      }, error => {
      });
    }

    returnToList() {
      this.router.navigateByUrl("/package");
    }
    
    AddToResources(resource){
      if(this.PackageObj.resources == null)
        this.PackageObj.resources = [];

        if(resource.isresourcecontainer)
        {
          let newRes: cResource = {
            groupname: "",
            id: uuidv4(),
            resourceId:resource.resourceId,
            name:resource.name,
            useClasses:resource.useClasses,
            exclusive:resource.exclusive,
            eventid: resource.eventid,
            concurrentUses:resource.concurrentUses,
            maxConcurrent:resource.maxConcurrent,
            disabled:resource.disabled,
            venueId:resource.venueId,
            colour:resource.colour,
            orderindex:resource.orderindex,
            length:resource.length,
            classes:resource.classes,
            showonbooking:resource.showonbooking,
            resources:resource.resources,
            isresourcecontainer:resource.isresourcecontainer,
            isconstructed: resource.isconstructed,
            price:resource.price,
            fixedprice:resource.fixedprice,
            resourcegroupname: resource.resourcegroupname,
            tags: resource.tags,
            resourcegroup: resource.resourcegroup,
            selectionmode: "SYSTEMANY",
            selectableresources: resource.selectableresources,
            startwhen: "ATSTART",
            startTimeOffset: 0,
            optional: false,
            quantityselector: "GROUPSIZE",
            quantity: resource.quantity,
            mode: "COMPLEX",
            inline: false,
            ignore: false,
            admissions: null,
            inProgress: true,
            originatingid: '',
            wasoptional: false,
            wasselected: false,
            isupgrade: false,
            packageupgradeid: null,
            showinitinerary: true,
            showondaysheet: true,
            cansplit: resource.cansplit
          }
  
          this.PackageObj.resources.push(newRes);
          newRes = null;
        }
        else
        {
          let newRes: cResource = {
            groupname: "",
            id: uuidv4(),
            resourceId:resource.resourceId,
            name:resource.name,
            useClasses:resource.useClasses,
            exclusive:resource.exclusive,
            eventid: resource.eventid,
            concurrentUses:resource.concurrentUses,
            maxConcurrent:resource.maxConcurrent,
            disabled:resource.disabled,
            venueId:resource.venueId,
            colour:resource.colour,
            orderindex:resource.orderindex,
            length:resource.length,
            classes:resource.classes,
            showonbooking:resource.showonbooking,
            resources:resource.resources,
            isresourcecontainer:resource.isresourcecontainer,
            isconstructed: resource.isconstructed,
            price:resource.price,
            fixedprice:resource.fixedprice,
            resourcegroupname: resource.resourcegroupname,
            tags: resource.tags,
            resourcegroup: resource.resourcegroup,
            selectionmode: "",
            selectableresources: resource.selectableresources,
            startwhen: "ATSTART",
            startTimeOffset: resource.startTimeOffset,
            optional: resource.optional,
            quantityselector: "GROUPSIZE",
            quantity: resource.quantity,
            mode: "SIMPLE",
            inline: true,
            ignore: false,
            admissions: null,
            inProgress: true,
            originatingid: '',
            wasoptional: false,
            wasselected: false,
            isupgrade: false,
            packageupgradeid: null,
            showinitinerary: true,
            showondaysheet: true,
            cansplit: resource.cansplit
          }
  
          this.PackageObj.resources.push(newRes);
          newRes = null;
        }

        this.buildItinerary();
    }

    AddToAdmissions(admission){
      if(this.PackageObj.admissions == null)
        this.PackageObj.admissions = [];

      let newAdm: cAdmission = {
        id: uuidv4(),
        name: admission.name,
        classid:null,
        bookingwizardtext: admission.bookingwizardtext,
        fixedPrice: admission.fixedPrice,
        participant: admission.participant,
        venueid: admission.venueid,
        admissionid: admission.admissionid,
        noofpeople: admission.noofpeople,
        price: admission.price,
        admissionClass: admission.admissionClass,
        min: admission.min,
        max: admission.max,
        index: admission.index,
        disabled: admission.disabled,
        mustinclude: admission.mustinclude,
        eventtickettype: admission.eventtickettype,
        counter: admission.counters,
        linkedadmissions: admission.linkedadmissions,
        uselinkedadmissions: admission.uselinkedadmissions,
        linkeddiscounts: admission.linkeddiscounts,
        uselinkeddiscounts: admission.uselinkeddiscounts,
        maxlinkeddiscounts:admission.maxlinkeddiscounts,
        maxlinkedadmissions:admission.maxlinkedadmissions,
        countstowardsmin: admission.countstowardsmin,
        countstowardsmax: admission.countstowardsmax,
        message: admission.message,
        fixed: admission.fixed,
        onlysetmax: admission.onlysetmax,
      }

      this.PackageObj.admissions.push(newAdm);
      this.availableAdmissions = this.availableAdmissions.filter(obj => obj.admissionid !== admission.admissionid);
    }

    removeFromAdmissions(admission){
      this.PackageObj.admissions = this.PackageObj.admissions.filter(obj => obj.id !== admission.id);
      
      if(this.availableAdmissions.findIndex(obj => obj.admissionid === admission.admissionid) < 0)
      {
        this.availableAdmissions.push(admission);
      }

      // sort the available admissions again
      this.availableAdmissions.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
    }

    removeFromResources(resource){
      this.PackageObj.resources = this.PackageObj.resources.filter(obj => obj.id !== resource.id);
      this.buildItinerary();
    }
    
    updateData() {

      // Check if first resource is simple
      if(this.PackageObj.resources.length > 0 && this.PackageObj.resources[0].mode == "COMPLEX")
      {
        this.messageService.add({ severity: 'error', summary: 'First Resource Issue', detail: 'You cannot have a complex resource as your first resource, please add a simple resource first.' });
      }
      else
      {
        if (this.DoValidCheck())
        {
          let AllOK: boolean = true;

          this.PackageObj.bookingtimeout = Number(this.BookingTimeout) * 60;

          if(this.PackageObj.admissions.length == 0)
          {
            this.messageService.add({ severity: 'error', summary: 'Admission missing', detail: 'You must have at least 1 admission' });
            AllOK = false;
          }

          if(this.PackageObj.resources.length == 0)
          {
            this.messageService.add({ severity: 'error', summary: 'Resource missing', detail: 'You must have at least 1 Resource' });
            AllOK = false;
          }

          let resourceHasNoLength: boolean = false;
          this.PackageObj.resources.forEach(element => {
            if(element.length == 0)
              resourceHasNoLength = true;
          });

          if(resourceHasNoLength)
          {
            this.messageService.add({ severity: 'error', summary: 'Resource length Issue', detail: 'All Resources must have a length greater than 0' });
            AllOK = false;
          }

          let ResourceHasClasses: boolean = false;
          let AdmissionsDontHaveClasses: boolean = false;

          this.PackageObj.resources.forEach(res => {
            if(res.useClasses == true)
            {
              ResourceHasClasses = true;
            }
          });

          if(ResourceHasClasses != false)
          {
            this.PackageObj.admissions.forEach(adm => {
              if(adm.admissionClass == null)
              {
                AdmissionsDontHaveClasses = true;
              }
            });

            if(AdmissionsDontHaveClasses)
            {
              this.messageService.add({ severity: 'error', summary: 'Class issue', detail: 'All Admissions must have a class if one or more of the resources in this package do.' });  
              AllOK = false;
            }
          }

          if(AllOK)
          {
            this.PackageObj.bookingscannotbemadewithinxminutes = (this.bookingCannotBeMadeWithinXMinutesD * 1440) + (this.bookingCannotBeMadeWithinXMinutesH * 60) + this.bookingCannotBeMadeWithinXMinutesM;

            this.PackageObj.bookingscannotbemadeafterxminutes = this.bookingscannotbemadeafterxDays * 1440;

            this.PackageObj.resources.forEach(element => {
              if(element.selectionmode == "ANY" || element.selectionmode == "SYSTEMANY")
              {
                element.selectableresources = element.resources;
              }
            });

            this.PackageObj.admissions.forEach(adm => {
              if(!adm.uselinkedadmissions)
              {
                adm.linkedadmissions = null;
              }

              if(!adm.uselinkeddiscounts)
                {
                  adm.linkeddiscounts = null;
                }
            });

            let index = 0;
            this.PackageObj.admissions.forEach(adm => {
              adm.index = index;
              index++;
            });

            const partyPattern = /party/i;
            const nameHasParty = partyPattern.test(this.PackageObj.name || '');
            const descHasParty = partyPattern.test(this.PackageObj.description || '');

            if ((nameHasParty || descHasParty) && !this.PackageObj.ispartypackage) {
              this.showPartyPackageDialog = true;
              return;
            }

            if (this.id === '0' && this.defaultBookingFee && !this.PackageObj.bookingfeeid) {
              this.showDefaultFeeDialog = true;
              return;
            }

            this.proceedWithSave();
          }
        }
      }
    }

    loadDefaultBookingFee(): void {
      this.http.get(bmxurl + 'BookingFeeList/' + this.VenueID + '/false').subscribe({
        next: (response: any) => {
          if (response.succeeded) {
            this.defaultBookingFee = (response.data ?? []).find((f: any) => f.isdefault === true) ?? null;
          }
        },
        error: () => {}
      });
    }

    confirmSetPartyPackage() {
      this.PackageObj.ispartypackage = true;
      this.showPartyPackageDialog = false;
      this.proceedWithSave();
    }

    confirmDefaultFee(): void {
      this.PackageObj.bookingfeeid = this.defaultBookingFee.bfid;
      this.showDefaultFeeDialog = false;
      this.proceedWithSave();
    }

    declineDefaultFee(): void {
      this.showDefaultFeeDialog = false;
      this.proceedWithSave();
    }

    proceedWithSave() {
      if (this.id == "0") {

        let index: number = 0;
        this.PackageObj.resources.forEach(res => {
          res.orderindex = index;
          let innerindex: number = 0;
          res.resources.forEach(innerres => {
            innerres.orderindex = innerindex;
            innerindex ++;
          });
          index ++;
        });

        this.PackageObj.resources.forEach(element => {
          if(element.mode == "SIMPLE")
          {
            element.selectionmode = '';
            element.startwhen = '';
          }
        });

        this.PackageObj.name = this.PackageObj.name.trim();

        this.PackageObj.startDate = ConvertDateToDB(this.PackageObj.startDate);
        this.PackageObj.endDate = ConvertDateToDB(this.PackageObj.endDate);

        this.PackageObj.discountstart = ConvertDateToDB(this.PackageObj.discountstart);
        this.PackageObj.discountend = ConvertDateToDB(this.PackageObj.discountend);

        this.applyRepeatDates();

        this.busyService.busy();
        this.http.post<packageObj>(bmxurl + "/package", this.PackageObj).subscribe(response => {
          this.busyService.idle();
          this.httpResponse = response
          if (this.httpResponse.succeeded) {
            this.messageService.add({ severity: 'success', summary: 'Saved', detail: 'Package successfully created' });
            this.router.navigateByUrl("/packagestarttimes/" + this.httpResponse.data.packageId);
          }
          else
          {
            this.messageService.add({ severity: 'error', summary: 'Error Occurred', detail: this.httpResponse.messages[0] });
          }
        }, error => {
          this.busyService.idle();
          this.messageService.add({ severity: 'error', summary: 'Not Saved', detail: error.messages });
        })
      }
      else
      {
        this.PackageObj.disabled = false;

        let index: number = 0;
        this.PackageObj.resources.forEach(res => {
          res.orderindex = index;
          let innerindex: number = 0;
          res.resources.forEach(innerres => {
            innerres.orderindex = innerindex;
            innerindex ++;
          });
          index ++;
        });

        this.PackageObj.name = this.PackageObj.name.trim();

        this.PackageObj.startDate = ConvertDateToDB(this.PackageObj.startDate);
        this.PackageObj.endDate = ConvertDateToDB(this.PackageObj.endDate);

        this.PackageObj.discountstart = ConvertDateToDB(this.PackageObj.discountstart);
        this.PackageObj.discountend = ConvertDateToDB(this.PackageObj.discountend);

        this.applyRepeatDates();

        this.busyService.busy();
        this.http.put<packageObj>(bmxurl + "/package", this.PackageObj).subscribe(response => {
          this.busyService.idle();
          this.httpResponse = response
          if (this.httpResponse.succeeded) {
            this.messageService.add({ severity: 'success', summary: 'Saved', detail: 'Package successfully updated' });
            this.router.navigateByUrl("/package");
          }
          else
          {
            this.messageService.add({ severity: 'error', summary: 'Error Occurred', detail: this.httpResponse.messages[0] });
          }
        }, error => {
          this.busyService.idle();
          this.messageService.add({ severity: 'error', summary: 'Not Saved', detail: error.messages });
        })
      }
    }

    delay(ms: number) {
      return new Promise( resolve => setTimeout(resolve, ms) );
  }

    buildItinerary()
    {
      this.delay(1000);

      let checkresources: resource[] = [];

      for (var i = 0; i < this.PackageObj.resources.length; i++)
      {
        let newRes: cResource = {
          groupname: "",
          id: uuidv4(),
          resourceId: this.PackageObj.resources[i].resourceId,
          name: this.PackageObj.resources[i].name,
          useClasses: this.PackageObj.resources[i].useClasses,
          exclusive: this.PackageObj.resources[i].exclusive,
          eventid: this.PackageObj.resources[i].eventid,
          concurrentUses: this.PackageObj.resources[i].concurrentUses,
          maxConcurrent: this.PackageObj.resources[i].maxConcurrent,
          disabled: this.PackageObj.resources[i].disabled,
          venueId: this.PackageObj.resources[i].venueId,
          colour: this.PackageObj.resources[i].colour,
          orderindex: this.PackageObj.resources[i].orderindex,
          length: this.PackageObj.resources[i].length,
          classes: this.PackageObj.resources[i].classes,
          showonbooking: this.PackageObj.resources[i].showonbooking,
          resources: this.PackageObj.resources[i].resources,
          isresourcecontainer: this.PackageObj.resources[i].isresourcecontainer,
          isconstructed:  this.PackageObj.resources[i].isconstructed,
          price: this.PackageObj.resources[i].price,
          fixedprice: this.PackageObj.resources[i].fixedprice,
          resourcegroupname:  this.PackageObj.resources[i].resourcegroupname,
          tags:  this.PackageObj.resources[i].tags,
          resourcegroup:  this.PackageObj.resources[i].resourcegroup,
          selectionmode:  this.PackageObj.resources[i].selectionmode,
          selectableresources:  this.PackageObj.resources[i].selectableresources,
          startwhen:  this.PackageObj.resources[i].startwhen,
          startTimeOffset:  this.PackageObj.resources[i].startTimeOffset,
          optional:  this.PackageObj.resources[i].optional,
          quantityselector:  this.PackageObj.resources[i].quantityselector,
          quantity:  this.PackageObj.resources[i].quantity,
          mode:  this.PackageObj.resources[i].mode,
          inline:  this.PackageObj.resources[i].inline,
          ignore:  this.PackageObj.resources[i].ignore,
          admissions: this.PackageObj.resources[i].admissions,
          inProgress: this.PackageObj.resources[i].inProgress,
          originatingid: this.PackageObj.resources[i].originatingid,
          wasoptional: this.PackageObj.resources[i].wasoptional,
          wasselected: this.PackageObj.resources[i].wasselected,
          isupgrade: this.PackageObj.resources[i].isupgrade,
          packageupgradeid: this.PackageObj.resources[i].packageupgradeid,
          showinitinerary: this.PackageObj.resources[i].showinitinerary,
          showondaysheet: this.PackageObj.resources[i].showondaysheet,
          cansplit: this.PackageObj.resources[i].cansplit
        }

        checkresources.push(newRes);
      }

      let startTime: number = 600;
      let minuteOffset: number = 0;
      let sessionLength: number = 0;

      this.itinerary = "";
      this.discrepantitinerary = [];

      checkresources.forEach(innerRes => {
        if (innerRes.inline)
        {
          sessionLength += innerRes.length;
        }
      });

      for (var i = 0; i < checkresources.length; i++)
      {
        if (checkresources[i].inline)
        {
          if(i == 0)
          {
            minuteOffset += 0;
            checkresources[i].orderindex = startTime + minuteOffset;
          }
          else
          {
            minuteOffset += checkresources[i - 1].length;
            checkresources[i].orderindex = startTime + minuteOffset;
          }
        }
        else
        {
          if(checkresources[i].startwhen == "ATEND")
          {
            checkresources[i].orderindex = startTime + sessionLength;
          }
          else if(checkresources[i].startwhen == "ATSTART")
          {
            checkresources[i].orderindex = startTime;
          }
          else if(checkresources[i].startwhen == "OFFSET")
          {
            checkresources[i].orderindex = startTime + checkresources[i].startTimeOffset;
          }
        }
      }

      checkresources = checkresources.sort((r1, r2) => {
          if (r1.orderindex > r2.orderindex) {
              return 1;
          }
      
          if (r1.orderindex < r2.orderindex) {
              return -1;
          }
      });

      minuteOffset = 0;

      for (var i = 0; i < checkresources.length; i++)
      {
        if(checkresources[i].startwhen == "ATSTART" && checkresources[i].inline == false)
        {
          this.itinerary += this.convertTime(startTime) + " - " + checkresources[i].name + " (" + checkresources[i].length + (checkresources[i].length == 1 ? " minute), " : " minutes), ");
        }
        else if(checkresources[i].startwhen == "ATEND" && checkresources[i].inline == false)
        {
          this.itinerary += this.convertTime(startTime + sessionLength) + " - " + checkresources[i].name + " (" + checkresources[i].length + (checkresources[i].length == 1 ? " minute), " : " minutes), ");
        }
        else
        {
          this.itinerary += this.convertTime(startTime + minuteOffset) + " - " + checkresources[i].name + " (" + checkresources[i].length + (checkresources[i].length == 1 ? " minute), " : " minutes), ");
          minuteOffset += checkresources[i].length;
        }
      }
     
      if (this.itinerary.length > 2)
      {
        this.itinerary = this.itinerary.substring(0, this.itinerary.length - 2)
      }
    }

    convertTime(mins: number)
    {
        var hours = Math.floor(mins / 60);          
        var minutes = mins % 60;
      
        return hours.toString().padStart(2, '0') + ":" + minutes.toString().padStart(2, '0');
    }

    NextRes(){  
      this.activeIndex = 1;
    }

    NextAds(){
      this.activeIndex = 2;
    }

    removeImage(){
      this.FileChosen = null;
      this.PackageObj.imageurl = null;
    }

    onMinChange(value: number): void {
      this.PackageObj.min = value;
      if (this.PackageObj.max > 0 && value > this.PackageObj.max) {
        this.PackageObj.max = value;
      }
      this.maxNotLessThanMinValid = !(this.PackageObj.max < value);
    }

    onMaxChange(value: number): void {
      this.PackageObj.max = value;
      this.maxNotLessThanMinValid = !(value < this.PackageObj.min);
    }

    onStartDateChange(date: Date): void {
      if (this.PackageObj.endDate && date > this.PackageObj.endDate) {
        this.PackageObj.endDate = new Date(date);
      }
    }

    onEndDateChange(date: Date): void {
      if (date && this.PackageObj.startDate && date < new Date(this.PackageObj.startDate)) {
        this.PackageObj.endDate = new Date(this.PackageObj.startDate);
      } else {
        this.PackageObj.endDate = date;
      }
    }

    //---- Repeat dates ------------------------------------------------------------------------------
    //Picked the way event dates are: a start date and time, repeating every so many hours, days, weeks
    //or months, into a Chosen list where any entry can be moved to Excluded (half term, a bank holiday)
    //and back again. These dates and times replace the package's Start and End Date and its Start
    //Times. Each is written out from the date and time as picked, so it cannot slip on its way to the
    //API.

    private repeatDateString(date: Date): string
    {
      return date.getFullYear() + "-" + ('00' + (date.getMonth() + 1)).slice(-2) + "-" + ('00' + date.getDate()).slice(-2) + "T" + ('00' + date.getHours()).slice(-2) + ":" + ('00' + date.getMinutes()).slice(-2) + ":00.000Z";
    }

    //That day at the chosen start time.
    private repeatAtStartTime(date: Date): Date
    {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate(), Number(this.RepeatStartHour), Number(this.RepeatStartMinute));
    }

    //How many different days are chosen - a day with several times counts once.
    get repeatDistinctDateCount(): number
    {
      return new Set(this.RepeatChosenDates.map(value => value.substring(0, 10))).size;
    }

    private repeatMidnight(date: Date): Date
    {
      const picked = new Date(date);
      return new Date(picked.getFullYear(), picked.getMonth(), picked.getDate());
    }

    private repeatDayChosen(date: Date): boolean
    {
      switch (date.getDay())
      {
        case 1: return this.RepeatMonday;
        case 2: return this.RepeatTuesday;
        case 3: return this.RepeatWednesday;
        case 4: return this.RepeatThursday;
        case 5: return this.RepeatFriday;
        case 6: return this.RepeatSaturday;
        default: return this.RepeatSunday;
      }
    }

    createRepeatDates()
    {
      this.RepeatDateError = false;

      const start = this.repeatMidnight(this.RepeatStartDate);
      const dates: Date[] = [];

      if (!this.RepeatDoesRepeat || this.ChosenRepeatOptionInterval == null || this.ChosenRepeatOptionInterval.code == 'No Repeat')
      {
        dates.push(start);
      }
      else
      {
        const end = this.repeatMidnight(this.RepeatEndDate);

        //Hours repeat within the start date, so the end date isn't used for them.
        if (this.ChosenRepeatOptionPeriod?.code != "Hour(s)" && start > end)
        {
          this.RepeatDateError = true;
          return;
        }

        const interval = Number(this.ChosenRepeatOptionInterval.code);

        switch (this.ChosenRepeatOptionPeriod?.code)
        {
          case "Hour(s)":
          {
            //Several times on the start date, from the start time up to the end time.
            const first = this.repeatAtStartTime(start);
            const last = new Date(start.getFullYear(), start.getMonth(), start.getDate(), Number(this.RepeatEndHour), Number(this.RepeatEndMinute));

            if (first > last)
            {
              this.RepeatDateError = true;
              return;
            }

            for (let time = new Date(first); time <= last; time = new Date(time.getFullYear(), time.getMonth(), time.getDate(), time.getHours() + interval, time.getMinutes()))
            {
              dates.push(time);
            }

            this.addRepeatDates(dates);
            return;
          }

          case "Day(s)":
            for (let day = new Date(start); day <= end; day = new Date(day.getFullYear(), day.getMonth(), day.getDate() + interval))
            {
              dates.push(day);
            }
            break;

          case "Week(s)":
          {
            if (!(this.RepeatMonday || this.RepeatTuesday || this.RepeatWednesday || this.RepeatThursday || this.RepeatFriday || this.RepeatSaturday || this.RepeatSunday))
            {
              this.messageService.add({ severity: 'error', summary: 'Choose a day', detail: 'Choose at least one day of the week for the package to run on.' });
              return;
            }

            //Every day is looked at, and a day is used when its switch is on and it falls in a week that
            //is due - every week, every other week and so on - counted from the start date's week.
            const startWeekday = (start.getDay() + 6) % 7;

            for (let day = new Date(start); day <= end; day = new Date(day.getFullYear(), day.getMonth(), day.getDate() + 1))
            {
              const daysIn = Math.round((day.getTime() - start.getTime()) / 86400000);
              const week = Math.floor((daysIn + startWeekday) / 7);

              if (week % interval == 0 && this.repeatDayChosen(day))
              {
                dates.push(day);
              }
            }
            break;
          }

          case "Month(s)":
            //The same day of the month each time. A month without that day (the 31st in a 30-day
            //month) is left out rather than rolling into the month after.
            for (let step = 0; ; step++)
            {
              const day = new Date(start.getFullYear(), start.getMonth() + (interval * step), start.getDate());

              if (day > end)
              {
                break;
              }

              if (day.getDate() == start.getDate())
              {
                dates.push(day);
              }
            }
            break;
        }
      }

      this.addRepeatDates(dates.map(date => this.repeatAtStartTime(date)));
    }

    private addRepeatDates(dates: Date[])
    {
      let alreadyChosen = 0;
      const chosen = [...this.RepeatChosenDates];

      dates.map(date => this.repeatDateString(date)).forEach(value => {
        if (chosen.includes(value))
        {
          alreadyChosen++;
          return;
        }

        chosen.push(value);
        this.RepeatExcludedDates = this.RepeatExcludedDates.filter(excluded => excluded != value);
      });

      this.RepeatChosenDates = chosen.sort();

      if (alreadyChosen > 0)
      {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: alreadyChosen == 1 ? 'You cannot add the same date more than once.' : alreadyChosen + ' of those dates were already chosen, so they were not added again.' });
      }
    }

    clearRepeatDates()
    {
      this.RepeatChosenDates = [];
    }

    excludeRepeatDate(value: string)
    {
      this.RepeatChosenDates = this.RepeatChosenDates.filter(chosen => chosen != value);
      this.RepeatExcludedDates = [...this.RepeatExcludedDates, value].sort();
    }

    restoreRepeatDate(value: string)
    {
      this.RepeatExcludedDates = this.RepeatExcludedDates.filter(excluded => excluded != value);
      this.RepeatChosenDates = [...this.RepeatChosenDates, value].sort();
    }

    private loadRepeatDates()
    {
      this.RepeatChosenDates = [...(this.PackageObj.repeatdates ?? [])].sort();
      this.RepeatExcludedDates = [];
      this.RepeatBlocks = (this.PackageObj.repeatblocks ?? []).map(block => ({
        blockid: block.blockid,
        name: block.name,
        dates: [...(block.dates ?? [])]
      }));

      if(this.PackageObj.repeatmode != 'BLOCKS')
      {
        this.PackageObj.repeatmode = 'FREE';
      }

      if(this.RepeatBlocks.length > 0)
      {
        this.RepeatSessionsPerBlock = this.RepeatBlocks[0].dates.length;
      }
    }

    //---- Fixed blocks ------------------------------------------------------------------------

    get repeatIsBlocks(): boolean
    {
      return this.PackageObj?.repeatmode == 'BLOCKS';
    }

    //Cuts the chosen dates into runs of the chosen length, in date order. A last block shorter
    //than the rest is kept rather than dropped - the venue can see it and adjust.
    buildRepeatBlocks()
    {
      const size = Number(this.RepeatSessionsPerBlock) || 0;

      if(size < 1)
      {
        this.messageService.add({severity:'error', summary:'Sessions per run', detail:'Enter how many sessions make up a run.'});
        return;
      }

      const dates = [...this.RepeatChosenDates].sort();

      if(dates.length == 0)
      {
        this.messageService.add({severity:'error', summary:'No dates', detail:'Add the dates first, then cut them into runs.'});
        return;
      }

      this.RepeatBlocks = [];

      for(let start = 0; start < dates.length; start += size)
      {
        const slice = dates.slice(start, start + size);

        this.RepeatBlocks.push({
          blockid: uuidv4(),
          name: 'Run ' + (this.RepeatBlocks.length + 1),
          dates: slice
        });
      }
    }

    clearRepeatBlocks()
    {
      this.RepeatBlocks = [];
    }

    removeRepeatBlock(block: repeatblock)
    {
      this.RepeatBlocks = this.RepeatBlocks.filter(item => item.blockid != block.blockid);
    }

    //What the block runs between, for the venue to read. The dates are the time written down
    //with a Z on the end, so the day is taken off the string rather than through a Date.
    blockRangeText(block: repeatblock): string
    {
      const dates = [...(block.dates ?? [])].sort();

      if(dates.length == 0)
      {
        return "No dates";
      }

      const day = (value: string) => value.substring(8, 10) + "/" + value.substring(5, 7) + "/" + value.substring(0, 4);

      return dates.length == 1
        ? day(dates[0])
        : day(dates[0]) + " to " + day(dates[dates.length - 1]);
    }

    //A date that is in no block is not bookable in Fixed blocks mode, so it is worth saying.
    get repeatDatesNotInABlock(): number
    {
      if(!this.repeatIsBlocks)
      {
        return 0;
      }

      const inBlocks = new Set(this.RepeatBlocks.flatMap(block => block.dates ?? []));

      return this.RepeatChosenDates.filter(date => !inBlocks.has(date)).length;
    }

    private applyRepeatDates()
    {
      this.PackageObj.repeatdates = [...this.RepeatChosenDates];
      this.PackageObj.repeatmode = this.PackageObj.repeatmode == 'BLOCKS' ? 'BLOCKS' : 'FREE';

      //Only blocks whose dates are still chosen are saved, so removing a date cannot leave a
      //block pointing at something the package no longer runs.
      const chosen = new Set(this.RepeatChosenDates);

      this.PackageObj.repeatblocks = this.repeatIsBlocks
        ? this.RepeatBlocks
            .map(block => ({
              blockid: block.blockid,
              name: (block.name ?? "").trim() == "" ? "Run" : block.name.trim(),
              dates: (block.dates ?? []).filter(date => chosen.has(date))
            }))
            .filter(block => block.dates.length > 0)
        : [];
    }

    DoValidCheck()
    {
      let AllValid = true;

      this.PackageObj.admissions.forEach(element => {
        if (!element.countstowardsmin && (element.message == null || element.message == ''))
          {
            AllValid = false;
            this.messageService.add({ severity: 'error', summary: 'Admission message required', detail: 'You must enter a message if any of your admission do not count towards the minimum numbers.' });
          }
      });

      if(this.PackageObj.publicDepositPolicy == null)
      {
        this.messageService.add({ severity: 'error', summary: 'Public Deposit Policy Required', detail: 'You must provide a Public Deposit Policy for your Package' });
        AllValid = false;
      }
      else

      if(this.PackageObj.venueDepositPolicy == null)
      {
        this.messageService.add({ severity: 'error', summary: 'Venue Deposit Policy Required', detail: 'You must provide a Venue Deposit Policy for your Package' });
        AllValid = false;
      }

      if(this.PackageObj.name == null || this.PackageObj.name == "")
      {
        AllValid = false;
        this.packageNameValid = false;
        if(this.activeIndex !=0)
          this.messageService.add({ severity: 'error', summary: 'Name Required', detail: 'You must provide a name for your Package, please return to the first tab and correct this.' });
      }
      else
      {
        this.packageNameValid = true;
      }

      if(this.PackageObj.description == null || this.PackageObj.description == "")
      {
        AllValid = false;
        this.packageDescValid = false;
        if(this.activeIndex !=0)
          this.messageService.add({ severity: 'error', summary: 'Description required', detail: 'You must provide a description for your Package, please return to the first tab and correct this.'});
      }
      else
      {
        this.packageDescValid = true;
      }

      if (this.PackageObj.max < this.PackageObj.min) {
        AllValid = false;
        this.maxNotLessThanMinValid = false;
        this.messageService.add({ severity: 'error', summary: 'Invalid Group Size', detail: 'Maximum Group Size cannot be less than Minimum Group Size.' });
      } else {
        this.maxNotLessThanMinValid = true;
      }

      if (this.PackageObj.endDate && this.PackageObj.startDate && new Date(this.PackageObj.endDate) < new Date(this.PackageObj.startDate)) {
        AllValid = false;
        this.messageService.add({ severity: 'error', summary: 'Invalid Date Range', detail: 'End Date cannot be before Start Date.' });
      }

      if (this.PackageObj.repeatable) {
        if (this.repeatDistinctDateCount < 2) {
          AllValid = false;
          this.messageService.add({ severity: 'error', summary: 'Repeat dates required', detail: 'A repeatable package needs at least 2 dates. Add them on the Repeat Dates tab.' });
        }

        //Every admission needs both session prices, set on the Admissions tab.
        const missingPrices = (this.PackageObj.admissions ?? []).filter((adm: any) => adm.allsessionsprice == null || adm.persessionprice == null);

        if (missingPrices.length > 0) {
          AllValid = false;
          this.messageService.add({ severity: 'error', summary: 'Session prices required', detail: 'Enter a price for all sessions and a price per session on every admission, on the Admissions tab.' });
        }

        //Not blocking - the package still saves - but staff won't be offered these when booking it.
        const hasRoomChoices = (this.PackageObj.resources ?? []).some((res: any) => res.mode == 'COMPLEX' || res.optional == true);

        if ((this.PackageObj.packageupgrades?.length ?? 0) > 0 || (this.PackageObj.packageabupgrades?.length ?? 0) > 0 || hasRoomChoices) {
          this.messageService.add({ severity: 'warn', summary: 'Not offered on repeatable packages', detail: 'Upgrades, add-ons and party room choices are not offered when booking a repeatable package yet.' });
        }
      }

      return AllValid;
    }

    
}

class UTCDate {
  private boundDateBacker: Date;
  constructor(private dateInstance: Date) {
    this.boundDateBacker = this.utcToLocal(dateInstance);
  }

  public get boundDate(): Date {
    return this.boundDateBacker;
  }
  public set boundDate(value: Date) {
    if (value) {
      this.dateInstance.setTime(this.localToUtc(value).getTime());
      const newTime = value.getTime();
      if (newTime !== this.boundDateBacker.getTime()) {
        this.boundDateBacker.setTime(newTime);
      }
    }
  }

  private localToUtc(date: Date): Date {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(),  date.getHours(), date.getMinutes(), date.getSeconds()));
  }

  private utcToLocal(date: Date): Date {
    return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),  date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
  }
}
